import React from 'react';
import { useMembershipShowContext } from '../../startup/MembershipShowApp';

function formatCurrencyCents(cents) {
  return ((cents || 0) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

function formatDate(value) {
  return value ? new Date(value).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) : '—';
}

export default function SubscriptionStats() {
  const { membership } = useMembershipShowContext();
  const invoices = membership.membership_invoices || [];
  const lifetimeValueCents = invoices.reduce((sum, invoice) => {
    return sum + (invoice.amount_paid_cents || 0) - (invoice.refunded_amount_cents || 0);
  }, 0);

  const interval = membership.interval;
  const intervalLabel = interval === 'year' ? 'Annual' : 'Monthly';
  const intervalShort = interval === 'year' ? 'year' : 'month';

  return (
    <div className="team-member-card mb-3 h-100">
      <div className="team-member-card-header">
        <div className="team-member-card-header-left">
          <div className="team-member-card-title-row">
            <h2 className="team-member-card-title">Subscription</h2>
          </div>
        </div>
      </div>
      <div className="team-member-card-body">
        <dl className="row mb-0">
          <dt className="col-5">Tier</dt><dd className="col-7">{intervalLabel}</dd>
          <dt className="col-5">Amount</dt>
          <dd className="col-7">{formatCurrencyCents(membership.amount_cents)} / {intervalShort}</dd>
          <dt className="col-5">Current period start</dt><dd className="col-7">{formatDate(membership.current_period_start)}</dd>
          <dt className="col-5">Current period end</dt><dd className="col-7">{formatDate(membership.current_period_end)}</dd>
          <dt className="col-5">Lifetime value</dt><dd className="col-7">{formatCurrencyCents(lifetimeValueCents)}</dd>
        </dl>
      </div>
    </div>
  );
}
